// ======================================================================
// File Name       : eachUserLiveCount
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { downloadFile } from '../../utils/index';
import { SELECT_TARGET_DATA, STRUCTURE_LEVEL } from '../../constants';

export function eachUserLiveCount(searchInfo) {
  return commonCallApi({
    path: 'live/EachUserLiveCount',
    data: { searchInfo },
  });
}
